/* eslint-disable no-underscore-dangle */
import {
  ref, computed,
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import router from '@/router'

export default function useUserDetails(ctx) {
  const userExternalId = router.currentRoute.query.externalId
  const userId = router.currentRoute.params.id
  if (userId && userExternalId) {
    const tabIndex = ref(0)
    if (ctx.root.$route.query['active-tab'] === 'wallet') {
      tabIndex.value = 1
    } else {
      tabIndex.value = 0
    }
    const toast = useToast()
    const userDetails = computed(() => ctx.root.$store.getters['users/getUserDetails'])
    const walletDetails = computed(() => ctx.root.$store.getters['users/getWalletDetails'])
    const userTransactions = computed(() => ctx.root.$store.getters['users/getUserTransactions'])
    const userPendingTransactions = computed(() => ctx.root.$store.getters['users/getUserPendingTransactions'])
    const userVisaTransactions = computed(() => ctx.root.$store.getters['users/getUserVisaTransactions'])
    const userPaymentMethods = computed(() => ctx.root.$store.getters['users/getUserPaymentMethods'])
    const fetchingUser = ref(false)
    const externalUserId = ctx.root._route.query.externalId
    const userProfilePic = ref(null)

    const fetchUserProfilePic = async () => {
      const pic = await ctx.root.$store.dispatch('users/getUserPicture', userId)
      userProfilePic.value = pic
    }
    const loading = ref(false)
    const fetchUserWallet = async () => {
      try {
        loading.value = true
        await ctx.root.$store.dispatch('users/fetchUserWallet', userId)
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }

    const fetchTransactionTypes = async () => {
      await ctx.root.$store.dispatch('transactionTypes/fetchTransactionTypes')
    }
    const transactionsLoading = ref(false)
    const fetchUserTransactions = async searchQuery => {
      try {
        transactionsLoading.value = true
        await ctx.root.$store.dispatch('users/fetchUserTransactions', searchQuery)
      } catch (error) {
        console.log(error)
      } finally {
        transactionsLoading.value = false
      }
    }

    const pendingTransactionsLoading = ref(false)
    const fetchUserPendingTransactions = async searchQuery => {
      try {
        pendingTransactionsLoading.value = true
        await ctx.root.$store.dispatch('users/fetchUserPendingTransactions', searchQuery)
      } catch (error) {
        console.log(error)
      } finally {
        pendingTransactionsLoading.value = false
      }
    }
    const visaTransactionsLoading = ref(false)
    const fetchVisaTransactions = async () => {
      try {
        visaTransactionsLoading.value = true
        await ctx.root.$store.dispatch('users/fetchUserVisaTransactions')
      } catch (error) {
        console.log(error)
      } finally {
        visaTransactionsLoading.value = false
      }
    }
    const userPaymentMethodsLoading = ref(false)
    const fetchPaymentMethods = async () => {
      try {
        userPaymentMethodsLoading.value = true
        await ctx.root.$store.dispatch('users/fetchPaymentMethods', userId)
      } catch (error) {
        console.log(error)
      } finally {
        userPaymentMethodsLoading.value = false
      }
    }
    const fetchUserDetails = async () => {
      try {
        fetchingUser.value = true

        await ctx.root.$store.dispatch('users/fetchUserDetails', userId)
      } catch (err) {
        const statusCode = err?.response?.status
        if (statusCode === 404 || statusCode === 500) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'User Not Found',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          ctx.root._router.push('/users')
        }
      } finally {
        fetchingUser.value = false
      }
    }
    const initUserData = async () => {
      fetchUserProfilePic()
      await fetchUserDetails()
      await fetchUserWallet()
      await fetchPaymentMethods()
      await fetchUserTransactions()
      await fetchUserPendingTransactions()
      await fetchVisaTransactions()
    }

    fetchTransactionTypes()
    initUserData()
    return {
      fetchingUser,
      fetchUserTransactions,
      transactionsLoading,
      pendingTransactionsLoading,
      fetchUserPendingTransactions,
      fetchVisaTransactions,
      visaTransactionsLoading,
      userVisaTransactions,
      fetchPaymentMethods,
      userPaymentMethodsLoading,
      userPaymentMethods,
      userTransactions,
      userPendingTransactions,
      walletDetails,
      userDetails,
      fetchUserDetails,
      loading,
      fetchUserWallet,
      tabIndex,
      externalUserId,
      userProfilePic,
    }
  }
  // push if no id or externalId provided
  return router.push('/users')
}
